<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <div style="max-height: 400px; overflow-y: auto;">
    </div>
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-50">[空白]</div>
  </mat-tab>
  <mat-tab #baseData label="網站股票資料">
    <app-stock-view03 [stockno]="stockno">

    </app-stock-view03>
  </mat-tab>
</mat-tab-group>
